import { FC, useEffect, useState } from "react";
import { MarkdownItHelperSingleton } from "Helpers";

type TMarkdownItComponent = {
    source: string,
    noSource?: string,
    env?: any | undefined,
    handleOnDoubleClick?: () => void,
    doLinkify?: boolean
}

export const MarkdownItComponent: FC<TMarkdownItComponent> = ({ source, noSource, env = undefined, handleOnDoubleClick, doLinkify }: TMarkdownItComponent) => {

    const [dangerousHtml, setDangerousHtml] = useState(source);

    useEffect(() => {
        setDangerousHtml(MarkdownItHelperSingleton.render(source, env, doLinkify));
    }, [source, env, doLinkify]);

    return(
        <>
            {source ? 
                <div dangerouslySetInnerHTML={{__html: dangerousHtml}} onDoubleClick={handleOnDoubleClick}></div>
                :
                <div onDoubleClick={handleOnDoubleClick}><p style={{fontStyle: "italic", color: "#CCCCCC"}}>{noSource ? noSource : "No description available."}</p></div>
            }
        </>
    );
};